module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "timeline text--blue img--100"
  }, [_c('h3', {
    staticClass: "column--half caps center timeline-descriptor"
  }, [_vm._v("Korean")]), _vm._v(" "), _c('h3', {
    staticClass: "column--half caps center timeline-descriptor"
  }, [_vm._v("English")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._l((_vm.milestones), function(milestone) {
    return _c('milestone', {
      key: milestone.title,
      attrs: {
        "milestone": milestone,
        "scrollBottom": _vm.scrollBottom
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text--blue"
  }, [_c('milestone', {
    key: _vm.lastMilestone.title,
    attrs: {
      "milestone": _vm.lastMilestone,
      "scrollBottom": _vm.scrollBottom
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e4d8ade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline.vue
// module id = 150
// module chunks = 0